<template>
  <div
    class="volume-control"
    @mouseenter="handleVolumeButtonMouseEnter"
    @mouseleave="handleVolumeButtonMouseLeave"
  >
    <VsIcon
      class="volume-control__button"
      :icon="'md:volume_' + volumeIconState"

      @click.native="handleVolumeButtonClicked"
    />
    <div
      v-if="sliderVisible"
      class="volume-control__slider"
    >
      <div class="slider">
        <div class="slider__track">
          <VsSlider
            class="slider__manipulator"
            :value="renderVolume"
            :wide="true"
            @input="changeVolume"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import VsIcon from '@/scripts/Components/Molecules/VsIcon';
import { getAnalyticPayload } from '@/scripts/libs/analytic';
import VsSlider from './VsSlider';

export default {
  components: {
    VsIcon,
    VsSlider,
  },
  props: {
    volume: {
      type: Number,
      required: true,
    },
    mute: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    this.debouncedAnalyticSender = debounce((newValue) => {
      this.analytic.send(
        getAnalyticPayload(
          e => e.player['control-bar'].click['volume-track'],
          {
            value: newValue - this.initialVolumeValue,
          },
        ),
      );
      this.initialVolumeValue = null;
    }, 700);

    return {
      sliderVisible: false,

      interactingWithVolumeTrack: false,

      initialVolumeValue: this.volume,
    };
  },
  computed: {
    volumeIconState() {
      switch (true) {
        case (this.renderVolume <= 0.0): return 'off';
        case (this.renderVolume < 20): return 'mute';
        case (this.renderVolume < 80): return 'down';
        default: return 'up';
      }
    },
    renderVolume() {
      if (this.mute) return 0;
      else return this.volume;
    },
  },

  methods: {
    changeVolume(newValue) {
      if (this.initialVolumeValue === null) {
        this.initialVolumeValue = this.volume;
      }

      this.debouncedAnalyticSender(newValue);
      this.$emit('setVolume', newValue);
    },

    handleVolumeButtonMouseEnter(event) {
      this.sliderVisible = true;
    },
    handleVolumeButtonMouseLeave(event) {
      this.sliderVisible = false;
    },
    handleVolumeButtonClicked() {
      this.analytic.send(
        getAnalyticPayload(
          e => e.player['control-bar'].click.volume,
        ),
      );
      this.$emit('toggleMute');
    },
  },
};
</script>

<style lang="scss" scoped>
.volume-control {
}

.volume-control {
  position: relative;
}
.volume-control__slider {
  background: rgba(black, 0.3); // Use UI overlay transparency
  left: 0;

  bottom: 100%;

  position: absolute;
  z-index: 1;
}

.volume-control__slider {
  $slider-height: 60px;
  $slider-width: 150px;
  $slider-track-width: 8px;
  $slider-track-knob-size: 16px;
  width: $slider-width;
  height: $slider-height;

  transform: translateX(#{$slider-height / 2}) rotate(270deg);
  transform-origin: bottom left;
  left: 50%;

  .slider {
    position: relative;
    width: 100%;
    height: 100%;
    padding: calc((#{$slider-height} - #{$slider-track-width})/2) 0;
    padding-left: 18px;
    padding-right: 36px;
    top: 50%;
    transform: translateY(-50%);

    .slider__track {
      background: rgba(white, 0.1);
      width: 100%;
      height: 100%;
      position: relative;
    }
  }
}

</style>
